import type { Props } from '../type';
import { SVGSolidIcon } from './SVGSolidIcon';

export const BottomArrowSolidIcon = (props: Props) => (
  <SVGSolidIcon color="#000000" {...props} viewBox="0 0 8 8">
    <path d="M8 2L4 6L0 2H8Z" />
  </SVGSolidIcon>
);
